import {GridColumnVisibilityModel} from "@mui/x-data-grid-pro";

// A missing key in a visibility model means "visible", so two models are
// equal when they hide exactly the same set of columns.
export const visibilityModelsEqual = (
    a: GridColumnVisibilityModel,
    b: GridColumnVisibilityModel
): boolean => {
    const hiddenA = Object.keys(a).filter((field) => a[field] === false).sort();
    const hiddenB = Object.keys(b).filter((field) => b[field] === false).sort();

    return hiddenA.length === hiddenB.length && hiddenA.every((field, i) => field === hiddenB[i]);
};
